export default __webpack_public_path__ + "assets/front/scss/classification-browsing.4614b98379bb2948d2929be875e2d60d.css";